import { Dispatch, SetStateAction, useCallback, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { Switch } from "@digital-services-gard-as/anchor-react";
import { useTranslation } from "react-i18next";

import { ClaimParams } from "@/api/claimsApi";

type ClosedClaimsSwitchProps = {
    resetPagination: () => void;
    setClaimsQuery: Dispatch<SetStateAction<ClaimParams>>;
};

const ClosedClaimsSwitch = ({ resetPagination, setClaimsQuery }: ClosedClaimsSwitchProps) => {
    const { t } = useTranslation("claimsInvoicesOverview");
    const [showClosedClaims, setShowClosedClaims] = useState<boolean>(false);

    const handleShowClosedClaims = useCallback(() => {
        const newShowClosedClaims = !showClosedClaims;
        if (newShowClosedClaims) {
            setClaimsQuery(prev => ({ queryFilter: { ...prev.queryFilter, status: "Closed" } }));
        } else {
            setClaimsQuery(prev => ({ queryFilter: { ...prev.queryFilter, status: "Open" } }));
        }
        resetPagination();

        setShowClosedClaims(newShowClosedClaims);
    }, [setClaimsQuery, showClosedClaims, resetPagination]);

    return (
        <Flex justifyContent="flex-end" alignItems="flex-end" mr="1rem" w="25%">
            <Flex alignItems="center" justifyContent="flex-end" h="50px">
                <Switch
                    id="closedClaimsOnly"
                    onChange={handleShowClosedClaims}
                    checked={showClosedClaims}
                    tabIndex={0}
                    position="right"
                >
                    {t("closedClaimsFilter")}
                </Switch>
            </Flex>
        </Flex>
    );
};

export default ClosedClaimsSwitch;
